'use client';

import { Modal, ModalBody } from '@coolblue-development/freddy';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { ProductTradeInContext } from '@features/product/components/ProductTradeIn/Context';
import { Actions } from '@features/product/components/ProductTradeIn/types';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { useContext } from 'react';

export const ExplanationContainer = () => {
  const modalTranslations = useFreddyTranslations('modal');
  const { isMobile } = useBreakpoints();
  const { explanationInfo, isExplanationModalOpen, dispatch } = useContext(ProductTradeInContext);

  return (
    isMobile && (
      <Modal
        translations={modalTranslations}
        open={isExplanationModalOpen || false}
        onClose={() => dispatch?.({ type: Actions.SET_EXPLANATION_MODAL, payload: false })}
        title={explanationInfo?.title}
        size='large'
        placement='bottom'
        body={<ModalBody>{explanationInfo?.explanation}</ModalBody>}
      />
    )
  );
};
